"use strict";

var _core = require("@emotion/core");

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("../../utils");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.Icon = utils_2.forwardRef(function Icon(props, ref) {
  var icon = props.icon,
      spin = props.spin,
      _a = props.type,
      type = _a === void 0 ? 'far' : _a;
  return (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: [type, icon],
    spin: spin
  });
});

if (utils_1.isDev) {
  exports.Icon.displayName = 'Tag';
}